var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('width:' + _vm.width + 'vw'),attrs:{"id":'parent' + _vm.id}},[_c('canvas',{attrs:{"height":_vm.height,"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }